import { ActivityPoint } from 'src/app/modules/shared/models/vehicle/vehicle-activity-point';
import { VehicleDeviation } from 'src/app/modules/shared/models/vehicle/vehicle-deviation';

export class ActivityPointListItem {
    arrivesTo: boolean;
    hasArrived: boolean;
    isLast: boolean;
    isFirst: boolean;
    hasDeparted: boolean;
    activityPoint: ActivityPoint;
    deviation: VehicleDeviation;
    visible: boolean = true;

    constructor(obj = null) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
